import http from "../http-common";

class PlanificationTypeService {
  getAll() {
    return http.get("/planification-types");
  }

  get(id) {
    return http.get(`/planification-types/${id}`);
  }

  create(data) {
    return http.post("/planification-types", data);
  }

  update(id, data) {
    return http.put(`/planification-types/${id}`, data);
  }

  delete(id) {
    return http.delete(`/planification-types/${id}`);
  }

  getTrashed() {
    return http.get("/planification-types/trashed/list");
  }

  restore(id) {
    return http.post(`/planification-types/${id}/restore`);
  }
}

export default new PlanificationTypeService();
